// extracted by mini-css-extract-plugin
export default {"background":"Home_background__mwFQc","centered":"Home_centered__KHn6F","content":"Home_content__dkjqU","video":"Home_video__hsTak"};